var _path, _path2, _g, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefineContext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49182 12.5835L13.1404 6.93494C12.3716 6.61501 11.4611 6.08941 10.5999 5.22828C9.73867 4.36702 9.21299 3.45634 8.89305 2.6875L3.24443 8.3361C2.80365 8.77692 2.58322 8.99734 2.39368 9.24028C2.17008 9.52699 1.97839 9.83714 1.82198 10.1653C1.68938 10.4435 1.59082 10.7393 1.39368 11.3306L0.354146 14.4493C0.257136 14.7403 0.332876 15.0611 0.549802 15.2781C0.766728 15.495 1.08759 15.5707 1.37862 15.4737L4.49724 14.4341C5.08863 14.237 5.38435 14.1385 5.66256 14.0059C5.99075 13.8495 6.30093 13.6578 6.58762 13.4342C6.83057 13.2446 7.05106 13.0242 7.49182 12.5835Z",
    fill: "url(#paint0_linear_26286_57766)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.652 5.34823C15.804 4.19623 15.804 2.32849 14.652 1.1765C13.5 0.0245011 11.6322 0.0245011 10.4801 1.1765L9.81476 1.8419C9.82391 1.86942 9.83329 1.89731 9.84311 1.92556C10.087 2.62856 10.5472 3.55011 11.4129 4.41578C12.2786 5.28144 13.2001 5.74162 13.9032 5.98552C13.9313 5.99528 13.9591 6.00468 13.9865 6.01375L14.652 5.34823Z",
    fill: "url(#paint1_linear_26286_57766)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_26286_57766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.305 9H15.5823C16.7446 9 17.6874 9.93611 17.6874 11.0901V13.5231C17.6874 13.5565 17.6863 13.5888 17.6853 13.6222C17.6863 13.6389 17.6874 13.6545 17.6874 13.6722V16.7693C17.6874 17.2978 17.2506 17.7283 16.7194 17.6846C16.2868 17.6491 15.932 17.3155 15.8805 16.8798C15.7503 16.147 15.1088 15.6132 14.3603 15.6132C12.0148 15.6143 7.30397 15.6143 7.30395 15.6143C7.30395 15.6143 7.30395 15.6143 7.30395 15.6143C6.14172 15.6143 5.19891 14.6782 5.19891 13.5242C5.19891 13.5242 5.19891 13.5242 5.19891 13.5242C5.19891 13.5242 5.19891 11.9709 5.19891 11.0911C5.19996 9.93611 6.14277 9 7.305 9Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45387 13.3568C9.01863 13.3568 9.47646 12.9023 9.47646 12.3415C9.47646 11.7808 9.01863 11.3262 8.45387 11.3262C7.8891 11.3262 7.43127 11.7808 7.43127 12.3415C7.43127 12.9023 7.8891 13.3568 8.45387 13.3568Z",
    fill: "url(#paint2_linear_26286_57766)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3121 13.3568C11.8768 13.3568 12.3347 12.9023 12.3347 12.3415C12.3347 11.7808 11.8768 11.3262 11.3121 11.3262C10.7473 11.3262 10.2895 11.7808 10.2895 12.3415C10.2895 12.9023 10.7473 13.3568 11.3121 13.3568Z",
    fill: "url(#paint3_linear_26286_57766)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.134 13.3568C14.6988 13.3568 15.1566 12.9023 15.1566 12.3415C15.1566 11.7808 14.6988 11.3262 14.134 11.3262C13.5693 11.3262 13.1115 11.7808 13.1115 12.3415C13.1115 12.9023 13.5693 13.3568 14.134 13.3568Z",
    fill: "url(#paint4_linear_26286_57766)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_26286_57766",
    x: 1.37002,
    y: 5.1711,
    width: 20.1463,
    height: 16.3453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.91445
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_26286_57766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_26286_57766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26286_57766",
    x1: 0.0453149,
    y1: 1.15083,
    x2: 13.0736,
    y2: 15.7158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26286_57766",
    x1: 3.87595,
    y1: -1.05343,
    x2: 15.4566,
    y2: 11.8932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86DCF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746EF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26286_57766",
    x1: 7.43127,
    y1: 11.4848,
    x2: 9.36804,
    y2: 13.2542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26286_57766",
    x1: 10.2895,
    y1: 11.4848,
    x2: 12.2263,
    y2: 13.2542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26286_57766",
    x1: 13.1115,
    y1: 11.4848,
    x2: 15.0482,
    y2: 13.2542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefineContext);
export default __webpack_public_path__ + "static/media/refine-context.eede0a028f6a031950baf76d28a8f1a8.svg";
export { ForwardRef as ReactComponent };